// Analytics
analytics.eventConfig.push({
    "target": ".component .table-bordered.product-list",
    "codeId": "a15",
    "events": [
        {
            "eventTarget": "a",
            "eventType": "click",
            "tags": {
                "componentId": "a15",
                "componentName": "product list",
                "destinationUrl": "",
                "elementText": "",
                "elementType": [
                    {
                        "rule": "$(context).parent().hasClass('product-list-icon')",
                        "value": "product list image"
                    },
                    {
                        "rule": "true",
                        "value": "product list link"
                    }
                ],
                "event": "navigation",
                "eventType": "product list internal navigation click",
                "listOrdinal": {
                    "ref": ".component",
                    "ele": "tr"
                },
                "listSource": "product",
                "titleText": "",
                'event1': '',
                'eventCategory': 'Customer Enablement & Education',
                'eventAction': '',
                'eventLabel': "",
                'external_url': "",
                'page_type': '',
                'page_title': '',
                'page_bu': "",
                'environment': "",
                'page_language': "",
                'sitecore_contact_id': "",
                'pardot_cookie_id': "",
                'document_title': "",
                'document_type': ""
            }
        }
    ]
});